<div class="atn-functional-usage-functionalizations__left">
  <span><b>Allocations</b></span>
  @for (func of allocationsSg(); track func.id) {
    <div class="atn-functional-usage-functionalizations__row">
      <div class="atn-functional-usage-functionalizations__info">
        <span>{{ formatFunctionLabel(func) }}</span>
        @for (tag of func.tags; track tag.text) {
          <atn-ds-tag
            class="atn-functional-usage-functionalizations__tag"
            [text]="tag.text"
            [style]="tag.style"
          />
        }
      </div>
      <span>{{ func.percent | percent: '1.0-0' }}</span>
    </div>
  }
</div>

<atn-ds-chart
  [chart]="{
    type: ChartTypeEnum.Donut,
    data: chartDataSg(),
    config: donutChartOptions,
  }"
/>
